<template>
  <span @keydown.enter.prevent="">
    <v-select
      :value="value"
      :label="label"
      :placeholder="placeholder"
      multiple
      :disabled="disabled"
      :value-comparator="valueComparator"
      :items="items"
      chips
      :item-text="itemRender"
      :item-value="itemSelect"
      class="select-field-multiple-custom-main-container"
      :menu-props="{ contentClass: 'select-field-multiple-custom-content' }"
      box
      :hint="hint"
      :persistent-hint="!!hint"
      :no-data-text="noDataText || (isAdminLocalization ? adminText('shared.noData', 'No data available') : undefined)"
      :error-messages="getErrors(validator)"
      @input="$emit('input', $event) && validator && validator.$touch()"
      @blur="validator && validator.$touch()"
      @change="$emit('change', $event) && validator && validator.$touch()"
    >
      <template v-slot:selection="{ item }">
        <v-chip class="select-field-multiple-custom-chip">
          <span>{{ item[itemRender] || item }}</span>
        </v-chip>
      </template>
    </v-select>
  </span>
</template>

<script>
import AdminContext from '@/admin-i18n/context'
import { defaultMessages, getValidationErrors } from '@/utils'

export default {
  mixins: [AdminContext],
  name: 'select-field-multiple',
  props: {
    disabled: Boolean,
    placeholder: {
      type: String,
      default: null,
    },
    chips: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: null,
    },
    value: {
      type: [String, Number, Object, Array],
      default: null,
    },
    items: {
      type: Array,
      default: () => [],
    },
    itemRender: {
      type: String,
      default: null,
    },
    itemSelect: {
      type: String,
      default: null,
    },
    validator: {
      type: Object,
      default: null,
    },
    errorMessages: {
      type: Object,
      default: null,
    },
    valueComparator: {
      type: Function,
      default: undefined,
    },
    hint: {
      type: String,
      default: undefined,
    },
    // Falls back to Vuetify's default ("No data available") when not provided.
    noDataText: {
      type: String,
      default: undefined,
    },
  },
  methods: {
    getErrors: function(field) {
      return getValidationErrors({
        ...this.adminValidationMessages(defaultMessages),
        ...this.adminFieldValidationMessages(this.errorMessages),
      })(field)
    },
  },
}
</script>
<style>
.select-field-multiple-custom-content .v-select-list {
  width: 100% !important;
  max-width: 692px !important;
}

.select-field-multiple-custom-content .v-list__tile {
  height: auto;
  margin: 10px 0;
}

.select-field-multiple-custom-content .v-list__tile__content {
  overflow: initial;
  flex: initial;
  height: auto;
  padding: 0;
  margin: 0;
  display: block;
}

.select-field-multiple-custom-main-container .v-select__selections {
  margin: 5px 0;
}

.select-field-multiple-custom-content .v-list__tile__title {
  text-overflow: initial;
  overflow: initial;
  white-space: initial;
  height: auto;
  line-height: initial;
  position: relative;
}

.select-field-multiple-custom-content .v-card {
  width: auto;
}

.select-field-multiple-custom-chip .v-chip__content {
  text-overflow: initial;
  overflow: initial;
  white-space: initial;
  height: auto;
  line-height: initial;
  position: relative;
  margin: 5px 0;
  overflow-wrap: anywhere !important;
}
</style>
